module.exports = __webpack_public_path__ + "static/media/IconPrint.864dec37.svg";